import { createClient } from '@supabase/supabase-js';

// Direct credentials - no environment variables
const supabaseUrl = 'https://yogylycpqusdeerbvbut.supabase.co';
const supabaseKey = 'sb_publishable_l1rFubGalbwZLrJhGouZWg_FOmxFGfF';

console.log('🚀 Initializing Supabase client...');
console.log('URL:', supabaseUrl);
console.log('Key:', supabaseKey.substring(0, 10) + '...');

const supabase = createClient(supabaseUrl, supabaseKey);

export { supabase };